import { useQuery } from '@tanstack/react-query';
import { userKeys } from 'src/data/api/orbit-service-ts/user/queries/keys';

export const useUserProgramIdQuery = ({ programId }: { programId: string }) =>
  useQuery({
    queryKey: userKeys.programId({ programId }),
    initialData: programId,
    queryFn: () => {
      // placeholder for actual implementation
      return programId;
    },
  });
